import * as Yup from 'yup';

export const SavingPlanVariantValidationSchema = Yup.object({
  minInvestment: Yup.number()
    .required('Minimum Investment is required')
    .positive('Minimum Investment must be a positive number')
    .integer('Minimum Investment must be an integer')
    .moreThan(0, 'Minimum Investment must be greater than zero'),
  maxInvestment: Yup.number()
    .required('Maximum Investment is required')
    .positive('Maximum Investment must be a positive number')
    .integer('Maximum Investment must be an integer')
    .moreThan(0, 'Maximum Investment must be greater than zero'),
  period: Yup.number()
    .required('Period is required')
    .positive('Period must be a positive number')
    .integer('Period must be an integer')
    .moreThan(0, 'Period  must be greater than zero'),
  multipleInvestment: Yup.number()
    .required('Multiple Investment is required')
    .positive('Multiple Investment must be a positive number')
    .integer('Multiple Investment must be an integer')
    .moreThan(0, 'Multiple Investment must be greater than zero'),
  makingChargesDiscount: Yup.number()
    .positive('Making Charges Discount must be a positive number')
    .integer('Making Charges Discount must be an integer'),
  diamondDiscount: Yup.number().when('category', {
    is: 'diamond',
    then: Yup.number()
      .positive('Diamond Discount must be a positive number')
      .integer('Diamond Discount must be an integer'),
  }),
  userBankRequired: Yup.boolean(),
});
